// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--HTmHp","image":"image--zXb4f"};